import { fetchAPI } from "../../../../../config/axios";
import {
  ParameterPenilaianAction,
  ParameterPenilaianActionType,
  ParameterPenilaianDataModel,
} from "./types";

export const ParameterPenilaian: ParameterPenilaianDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const ParameterPenilaianReducer = (
  state: ParameterPenilaianDataModel = ParameterPenilaian,
  action: ParameterPenilaianAction
): ParameterPenilaianDataModel => {
  switch (action.type) {
    case ParameterPenilaianActionType.GetParameterPenilaian:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const ParameterPenilaianCommand = {
  GetParameterPenilaian: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaians",
          { params }
        );
        dispatch({
          type: ParameterPenilaianActionType.GetParameterPenilaian,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateParameterPenilaian: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateParameterPenilaian: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteParameterPenilaian: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-parameter-penilaian",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
